import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ThemeEntity } from './theme.entity';

@Index('_fk__theme__id', ['fkThemeId', 'name'], { unique: true })
@Entity('_theme_property')
export class ThemePropertyEntity extends BaseEntity {
	@Column('int', { name: '_fk__theme__id', unsigned: true })
	public fkThemeId!: number;

	@Column('varchar', { name: 'name', length: 64, nullable: false })
	public name!: string;

	@Column('varchar', { name: 'value', length: 255, nullable: true })
	public value!: string;

	@ManyToOne(() => ThemeEntity, (theme) => theme.themeProperties, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn([{ name: '_fk__theme__id', referencedColumnName: 'id' }])
	public fkTheme!: ThemeEntity;
}
